/* eslint-disable */

export default (checkRenderedDom) => {
  let timeout = null;
  const fixRatio = () => {
    const appElement = document.getElementById('app');
    const wrapperHeight = appElement.clientHeight;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const isWide = ((windowWidth / windowHeight) < 1.77);
    const documentFontSize = document.documentElement.style.fontSize;
    const appWidth = appElement.style.width;
    const appHeight = appElement.style.height;
    if (isWide) {
      if (documentFontSize !== '1.01vw') {
        document.documentElement.style.fontSize = '1.01vw';
      }
      if (appWidth !== '100%') {
        appElement.style.width = '100%';
      }
      if (appHeight !== `${windowWidth * 0.555}px`) {
        appElement.style.height = `${windowWidth * 0.555}px`;
      }
    } else {
      if (documentFontSize !== '1.8vh') {
        document.documentElement.style.fontSize = '1.8vh';
      }
      if (appWidth !== `${wrapperHeight * 1.77}px`) {
        appElement.style.width = `${wrapperHeight * 1.77}px`;
      }
      if (appHeight !== 'auto') {
        appElement.style.height = 'auto';
      }
    }
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => checkRenderedDom(), 500);
  };
  setTimeout(fixRatio, 100);
  window.addEventListener('resize', fixRatio);
};
